import { useNavigate } from "@tanstack/react-router";
// Utils
import { currencyFormatter } from "../utils/Utils";
// Components
import { DataTable } from "./DataTable";

const columns = [
  { accessorKey: "no", header: "No.", meta: { minWidth: 200 } },
  {
    accessorKey: "postingDate",
    header: "Invoice Date",
    meta: { minWidth: 150 },
  },
  {
    accessorKey: "yourReference",
    header: "Reference",
    meta: { minWidth: 150 },
  },
  {
    id: "amount",
    accessorFn: (row) => currencyFormatter(row.currencyCode, row.amount),
    header: "Total",
    meta: { minWidth: 150 },
  },
];

export const CreditNoteTable = ({ data, loading, filter, setFilter }) => {
  const navigate = useNavigate();

  const creditNotes = data?.crmemo || [];
  const rowCount = Number(data?.paging?.noOfRecords) || 0;

  const pagination = {
    page: (filter?.page ?? 1) - 1,
    pageSize: filter?.pageSize ?? 25,
  };

  const handlePaginationChange = (next) => {
    setFilter((prevState) => ({
      ...prevState,
      page: next.page + 1,
      pageSize: next.pageSize,
    }));
  };

  return (
    <DataTable
      aria-label="Credit notes"
      columns={columns}
      rows={creditNotes}
      getRowId={(row) => row.no}
      rowCount={rowCount}
      page={pagination.page}
      pageSize={pagination.pageSize}
      loading={loading}
      onPaginationChange={handlePaginationChange}
      onRowClick={(row) => navigate({ to: `/credit/${row.no}` })}
    />
  );
};
